module.exports = __webpack_public_path__ + "static/media/edit-3.4932425e.svg";